import { useState, useContext } from "react"
import Button from "@material-tailwind/react/Button"
import Icon from "@material-tailwind/react/Icon"
import AdminNavbar from "./AdminNavbar"
import SidebarItem from "./SidebarItem"
import AuthContext from "../../context/AuthContext"
import "../../assets/styles/sidebar.css"

const Sidebar = () => {
  const [showSidebar, setShowSidebar] = useState("-left-64")
  const authContext = useContext(AuthContext)

  const logoutHandler = () => {
    authContext.logout(true)
  }

  return (
    <>
      <AdminNavbar setShowSidebar={setShowSidebar} />
      <div
        id='sidebar'
        className={`h-screen fixed top-0 lg:left-0 ${showSidebar} overflow-scroll bg-gray-900 w-64 z-10 py-4 px-6 transition-all duration-300 z-50`}>
        <div className='flex flex-col justify-between h-full'>
          <ul className='list-none'>
            <Button
              className='lg:hidden'
              color='transparent'
              buttonType='link'
              size='lg'
              iconOnly
              rounded
              ripple='light'
              onClick={() => setShowSidebar("-left-64")}>
              <Icon name='close' size='2xl' color='white' />
            </Button>
            <br></br>
            <SidebarItem
              route={"/today"}
              iconName={"date_range"}
              text={"Accesos Hoy"}
              setShowSidebar={setShowSidebar}
            />
            <SidebarItem
              route={"/history"}
              iconName={"schedule"}
              text={"Historial De Accesos"}
              setShowSidebar={setShowSidebar}
            />
            <SidebarItem
              route={"/employees"}
              iconName={"person"}
              text={"Empleados"}
              setShowSidebar={setShowSidebar}
            />
            <SidebarItem
              route={"/suppliers"}
              iconName={"local_shipping"}
              text={"Proveedores"}
              setShowSidebar={setShowSidebar}
            />
            <SidebarItem
              route={"/contractors"}
              iconName={"construction"}
              text={"Subcontratistas"}
              setShowSidebar={setShowSidebar}
            />
            <SidebarItem
              route={"/worksites"}
              iconName={"fmd_good"}
              text={"Obras"}
              setShowSidebar={setShowSidebar}
            />
            <SidebarItem
              route={"/users"}
              iconName={"face"}
              text={"Usuarios"}
              setShowSidebar={setShowSidebar}
            />
          </ul>
          <div>
            <Button
              className='flex items-center gap-4 text-sm text-white font-bold px-4 py-3 rounded-lg mb-4'
              color='transparent'
              buttonType='link'
              size='sm'
              ripple='light'
              onClick={logoutHandler}>
              <Icon name='exit_to_app' size='2xl' color='white' />
              Salir
            </Button>
          </div>
        </div>
      </div>
    </>
  )
}

export default Sidebar
